<template>
  <v-container px-5>
    <v-app-bar app elevation="0" color="indigo lighten-5">
      
      <v-spacer></v-spacer>
      <language-switcher class="mr-2"></language-switcher>
      <v-btn
        rounded
        elevation="0"
        color="primary"
        dark
        class="mr-2 px-3"
        @click="singIn"
        >{{ $t('sign_in') }}</v-btn
      >
      <v-btn
        rounded
        elevation="0"
        outlined
        color="secondary"
        dark
        class="px-3"
        @click="singUp"
        >{{ $t('registry') }}</v-btn
      >
    </v-app-bar>

    <v-row class="text-center">
      <v-col cols="12">
        <v-img
          :src="require('../assets/logo.svg')"
          class="mt-0"
          contain
          height="55"
        />
      </v-col>
    </v-row>

    <v-row class="text-center">
      <v-col cols="12">
        <div
          class="text-sm-h5 text-md-h4 text-lg-h4 text-xl-h4 text-h5 font-weight-thin"
          v-html="$t('slogan_html')"
        ></div>
      </v-col>
    </v-row>

    <v-row class="text-center">
      <v-col cols="12">
        <img src="../assets/cover.svg" style="max-height:300px" />
      </v-col>
    </v-row>

    <!-- <h2 class="headline font-weight-bold mb-3">What's next?</h2> -->

    <v-row class="text-center">
      <v-col cols="12">
        <v-btn
          rounded
          elevation="0"
          outlined
          large
          color="secondary"
          dark
          class="ma-1"
          >{{ $t('entities') }}</v-btn
        >
        <v-btn
          rounded
          elevation="0"
          color="secondary"
          large
          dark
          class="ma-1"
          >{{ $t('providers') }}</v-btn
        >
      </v-col>
    </v-row>
    <v-row class="text-center">
      <v-col cols="12">
        <h2 class="font-weight-regular primary--text">
          ¿Qué es Kronym?
        </h2>
        <p class="text-h6 font-weight-light">
          Kronym es la solución por excelencia para la gestión, control y
          seguimiento óptimo y simplificado de cronogramas de procesos de
          contratación pública que proporciona un marco conceptualmente novedoso
          orientado a impulsar la productividad, la capacidad de respuesta y la
          eficiencia de usuarios y operadores del Sistema Nacional de
          Contratación Pública en la gestión de sus procesos.
        </p>
      </v-col>
    </v-row>

    <v-row class="text-center">
      <v-col cols="12">
        <h2 class="font-weight-regular primary--text">
          ¿Por qué usar Kronym?
        </h2>
        <p class="text-h5 font-weight-normal font-italic secondary--text py-5">
          Control y observabilidad de los estados y cronogramas de los procesos
          de contratación pública, aspectos duales de un mismo problema con el
          que a diario se enfrentan los usuarios y operadores del Sistema
          Nacional de Contratación Pública.
        </p>
        <p class="text-h6 font-weight-light">
          Si alguna vez se le ha pasado el tiempo para la entrega de una oferta,
          de una puja de Subasta Inversa Electrónica, de una manifestación de
          interés de Menor Cuantía o de una Convalidación de Errores de aquel
          proceso de contratación pública que era muy importante para su
          negocio, entonces, sabrá con certeza que estar pendiente de los
          estados y de los cronogramas de los procesos de contratación es de
          vital importancia para cualquier empresa que participe en compras
          públicas. Por otro lado, un proceso puede ser cancelado o declarado
          desierto o reprogramado su cronograma, si eso ocurre, y tiene varios
          procesos al mismo tiempo, puede perder rápidamente el control de las
          prioridades e impactar negativamente en la productividad de su
          organización y obstaculizará el logro de los objetivos.
        </p>
      </v-col>
    </v-row>

    <v-row class="text-center">
      <v-col cols="12">
        <h2 class="font-weight-regular primary--text">
          Funciones y características
        </h2>
      </v-col>
    </v-row>

    <v-row class="text-center">
      <v-col cols="12">
        <v-simple-table class="text-h5">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-center text-h6 secondary--text">
                  Descripción
                </th>
                <th class="text-center text-h6 secondary--text">
                  Proveedores
                </th>
                <th class="text-center text-h6 secondary--text">
                  Entidades Contratantes
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="feature in features" :key="feature.name">
                <td class="text-body-2 font-weight-regular">
                  {{ feature.name }}
                </td>
                <td v-if="typeof feature.providers === 'boolean'">
                  <v-icon v-if="feature.providers" color="primary"
                    >mdi-check</v-icon
                  >
                </td>
                <td v-else>
                  {{ feature.providers }}
                </td>
                <td v-if="typeof feature.entities === 'boolean'">
                  <v-icon v-if="feature.entities" color="primary"
                    >mdi-check</v-icon
                  >
                </td>
                <td v-else>
                  {{ feature.entities }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>

    <v-row class="text-center">
      <v-col cols="12" class="primary pa-10">
        <h1 class="font-weight-regular white--text">
          Solicite una demostración y pruébelo grátis por 30 días
        </h1>
        <v-btn
          class="mt-5"
          large
          dark
          rounded
          elevation="0"
          outlined
          @click="requestDemo"
          >{{ $t('Solicitar demostración') }}</v-btn
        >
      </v-col>
    </v-row>

    <v-row class="text-center">
      <v-col cols="12">
        <h2 class="font-weight-regular primary--text">
          Comentarios de nuestros clientes
        </h2>
      </v-col>
    </v-row>

    <v-row class="text-center">
      <v-col cols="12">
        <v-carousel
          height="auto"
          cycle
          interval="15000"
          hide-delimiter-background
          :show-arrows="false"
          show-arrows-on-hover
          light
          justify="center"
        >
          <v-carousel-item v-for="(review, i) in reviews" :key="i">
            <v-avatar size="62">
              <img :src="review.photoURL" :alt="review.displayName" />
            </v-avatar>
            <p class="text-body-2 font-weight-light font-italic">
              <strong>{{ review.displayName }}</strong
              ><br />
              {{ review.position }}<br />
              {{ review.organization }}
            </p>
            <p
              class="text-h6 font-weight-light font-italic mx-md-15 px-md-15 pb-10"
            >
              <span class="text-h5 font-weight-light font-italic">"</span>
              {{ review.review }}
              <span class="text-h5 font-weight-light font-italic">"</span>
            </p>
          </v-carousel-item>
        </v-carousel>
      </v-col>
    </v-row>

    <v-row class="text-center">
      <v-col cols="12">
        <h2 class="font-weight-regular primary--text">
          Preguntas frecuentes
        </h2>
      </v-col>
    </v-row>

    <v-row class="text-center">
      <v-col cols="12" v-for="(faq, i) in faq" :key="i">
        <h3 class="font-weight-regular secondary--text">
          {{ i + 1 }}.-{{ faq.question }}
        </h3>
        <p class="text-h6 font-weight-light">
          {{ faq.answer }}
        </p>
      </v-col>
    </v-row>
    <!--   <v-col class="mb-5" cols="12">
        <h2 class="headline font-weight-bold mb-3">Important Links</h2>

        <v-row justify="center">
          <a
            v-for="(link, i) in importantLinks"
            :key="i"
            :href="link.href"
            class="subheading mx-3"
            target="_blank"
          >{{ link.text }}</a>
        </v-row>
      </v-col>

      <v-col class="mb-5" cols="12">
        <h2 class="headline font-weight-bold mb-3">Ecosystem</h2>

        <v-row justify="center">
          <a
            v-for="(eco, i) in ecosystem"
            :key="i"
            :href="eco.href"
            class="subheading mx-3"
            target="_blank"
          >{{ eco.text }}</a>
        </v-row>
      </v-col>-->
  </v-container>
</template>

<script>
import LanguageSwitcher from '@/components/LanguageSwitcher';
import faq from '@/assets/data/faq';
import reviews from '@/assets/data/reviews';
export default {
  name: 'Home',
  components: { LanguageSwitcher },
  data: () => ({
    faq,
    reviews,
    features: [
      {
        name: 'Componentes de automatización',
        providers: 'RPA Unit',
        entities: 'RPA Unit & RPA Stack'
      },
      {
        name: 'Gestión inteligente de cronogramas basado en prioridades',
        providers: true,
        entities: true
      },
      {
        name: 'Indicadores visuales de prioridad por etapas de cronogramas',
        providers: true,
        entities: true
      },
      {
        name: 'Indicadores visuales de prioridad por estado del procedimiento',
        providers: true,
        entities: true
      },
      {
        name:
          'Estados virtuales para las etapas de "Convalidación de Errores" y "Preguntas, Respuestas y Aclaraciones"',
        providers: true,
        entities: true
      },
      {
        name:
          'Notificación de cambios de estados y de cronogramas en pantalla y por correo electrónico',
        providers: true,
        entities: true
      },
      {
        name: 'Prealertas y Recordatorios en pantalla',
        providers: true,
        entities: true
      },
      {
        name: 'Seguimiento de Adjudicaciones',
        providers: true,
        entities: true
      },
      {
        name: 'Seguimento de Contratos',
        providers: true,
        entities: true
      },
      {
        name: 'Seguimento de Garantias Técnicas',
        providers: true,
        entities: true
      },
      {
        name: 'Segimiento de Pólizas de Fianzas',
        providers: true,
        entities: true
      },
      {
        name: 'Reportes y Estadísticas de Procesos',
        providers: true,
        entities: true
      },
      {
        name: 'Bitácora de procesos (Anotaciones)',
        providers: true,
        entities: true
      },
      {
        name: 'Aprovisionamiento de usuarios para procesos específicos',
        providers: true,
        entities: true
      },
      {
        name: 'Acceso a Kronym desde dispositivos móviles',
        providers: true,
        entities: true
      }
    ],
    ecosystem: [
      {
        text: 'vuetify-loader',
        href: 'https://github.com/vuetifyjs/vuetify-loader'
      },
      {
        text: 'github',
        href: 'https://github.com/vuetifyjs/vuetify'
      },
      {
        text: 'awesome-vuetify',
        href: 'https://github.com/vuetifyjs/awesome-vuetify'
      }
    ],
    importantLinks: [
      {
        text: 'Documentation',
        href: 'https://vuetifyjs.com'
      },
      {
        text: 'Chat',
        href: 'https://community.vuetifyjs.com'
      },
      {
        text: 'Made with Vuetify',
        href: 'https://madewithvuejs.com/vuetify'
      },
      {
        text: 'Twitter',
        href: 'https://twitter.com/vuetifyjs'
      },
      {
        text: 'Articles',
        href: 'https://medium.com/vuetify'
      }
    ],
    whatsNext: [
      {
        text: 'Explore components',
        href: 'https://vuetifyjs.com/components/api-explorer'
      },
      {
        text: 'Select a layout',
        href: 'https://vuetifyjs.com/getting-started/pre-made-layouts'
      },
      {
        text: 'Frequently Asked Questions',
        href: 'https://vuetifyjs.com/getting-started/frequently-asked-questions'
      }
    ]
  }),
  methods: {
    singIn() {
      this.$router.push({ path: '/sign-in' });
    },
    singUp() {
      this.$router.push({ path: '/select-country' });
    },
    requestDemo() {
      this.$router.push({ path: '/request-demo' });
    }
  }
};
</script>
